import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/conexao",

        async list({ page, filters }) {
            const url = this.userUrl();

            const query = {
                nome: filters.search,
                ordem: filters.orderBy,
                desc: filters.desc,
                locals: filters.local,
                page
            };

            return await Vue.http.get(url, {
                params: query,
            });
        },
    },
    base
);
